<script lang="ts">
    import AgendaItem from "../components/AgendaItem.svelte";
    import Footer from "../components/Footer.svelte";
    import Page from "../components/Page.svelte";
    import { useLocation } from "../components/router/context";
    import type { Agenda } from "../types/agenda";

    import { backIn, backOut } from 'svelte/easing';
    import { scale } from 'svelte/transition';
    
    const { navigate } = useLocation();

    let showPopup = false;

    const agendaItems: Agenda[] = [
        {
            time: "09:00-09:40",
            topic: "Gathering & Breakfast",
            details: ""
        },{
            time: "09:40-10:00",
            topic: "SAP Labs Isreal d-com 2025 Kick-Off",
            details: "Orena Kleinmann | Managing Director SAP Labs Israel"
        },{
            time: "10:00-11:00",
            topic: "Labs Israel Excellence: Product Demos",
            details: [
                {
                    topic: "Business Data Cloud Powered By Unified Services Suite Provisioning", 
                    details: "Michal Keider, CFS & Yaniv Yancovich, BDC&I & Michael Gorokhovsky, BDC Cockpit"
                },{
                    topic: "AI-Driven Development with SAP Build Code",
                    details: "Licam Oved & Liat Borenstein, SAP Build"
                },{
                    topic: "Turning Unknow Users into Loyal Brand Advocates",
                    details: "Igal Miroshnichenko & Dina Vinter & Ben Ohana, Customer Data Cloud (CDC)"
                }
            ]
        },{
            time: "11:00-11:20",
            topic: "Break",
            break: true
        },{
            time: "11:20-12:00",
            topic: "Customer Journey: El Al Israel Airlines",
            details: "Shlomy Zarfany | VP Commercial & Industry Affairs | EL AL Israel Airlines"
        },{
            time: "12:00-12:45",
            topic: "What Has Technology Done to the Brain? The Human Brain in the Age of Artificial Intelligence",
            details: "Dr. Liat Yakir | Lecturer & researcher of the biology of emotions"
        },{
            time: "12:45-14:20",
            topic: "Lunch Break | Rock Climbing!",
            break: true
        },{
            time: "14:20-15:00",
            topic: "SAP Labs Israel HackAI Challenge",
            details: "Daniel Nemeth | SAP Labs Israel AI Guild"
        },{
            time: "15:00-15:45",
            topic: "Enabling SAP Success",
            details: [
                {
                    topic: "How Data Drive Marketing and Business Transformation Flows",
                    details: "Idan Mutzary, Team Lead, Customer Data Platform<br>Ori Agranat, Tech Lead, Customer Data Platform"
                },{
                    topic: "Unleashing SAP Joule: Capabilities, Integrations, and Extensibility for the Future",
                    details: "Iris Sasson, Product Manager, SAP Build"
                },{
                    topic: "Future of Programming: A Glimpse into Tomorrow's Code",
                    details: "Asaf Bruner, Engineering Group Manager, Central Cloud Services<br>Eliav Amar, Software Engineer, SAP Build"
                }
            ]
        },{
            time: "15:45-16:00",
            topic: "SAP Labs Israel Recognition Awards",
            details: "Orna Kleinmann"
        },{
            time: "16:00-16:30",
            topic: "Yaki Gani",
            details: "Band Member Rockfour & Stuff Partner and Co-Founder"
        }
    ];
</script>

{#snippet footerSlot()}
    <Footer title="Want to stay up to date with<br>the latest news and events?" url="/subscribe" btnTitle="Subscribe Now!"  />
{/snippet}

<Page footer={footerSlot}>
    <div class="bg bg-no-repeat bg-cover bg-fixed flex flex-col w-full h-150 mb-8">
        <div class="h-full flex-col items-center flex justify-center">
            <h1 class="text-4xl uppercase mb-8"><b>SAP</b> Labs Israel</h1>
            <img class="col-end-1 max-h-45 mb-12 object-contain" src="/img/league-logo.png" alt="developer league logo" />
            <div class="flex max-md:flex-col items-center justify-between">
                <button onclick={() => navigate('/subscribe') } class="bg-indigo-500 h-14 px-8 rounded-lg cursor-pointer text-xl shadow-sm shadow-black active:shadow-2xs hover:bg-indigo-600">Subscribe Now!</button>
                <button onclick={() => showPopup = true } class="bg-indigo-300 text-black min-md:ml-3 h-14 px-8 rounded-lg max-md:mt-3 cursor-pointer text-xl shadow-sm shadow-black active:shadow-2xs hover:bg-indigo-400">How To Configure CDC</button>    
            </div>
        </div>
    </div>
    <article class="container mx-auto px-4 grid grid-cols-1 gap-y-8">
        <h2 class="font-bold italic text-4xl mb-6">Agenda</h2>
        {#each agendaItems as a}
            <AgendaItem item={a} />
        {/each}
    </article>
    {#if showPopup}
    <div in:scale={{ duration: 400, easing: backOut }} out:scale={{ duration: 400, easing: backIn}} class="absolute z-50 top-0 right-0 left-0 bottom-0 flex justify-center items-center">
        <article class="flex flex-col min-md:w-6/12 max-md:w-10/12 h-104 bg-indigo-300 rounded-2xl shadow-md shadow-indigo-500 border-1 border-indigo-950 overflow-hidden">
            <h2 class="text-xl px-4 py-3 border-b-indigo-950 border-b-1 text-indigo-950 flex justify-between items-center">
                <span>How To Configure Customer Data Cloud</span>    
                <button class="cursor-pointer w-8 h-8" onclick={() => showPopup = false}>x</button>
            </h2>
            <div class="flex-grow bg-indigo-50 text-black p-2 overflow-scroll">
                Add web SDK scrip tag to your page header:
                <div class="border-b-1 my-1 border-black"></div>
                <pre><code lang="html" class="text-xs text-indigo-900">&lt;script src=&quot;https://cdns.eu1.gigya.com/js/gigya.js?apiKey=API_KEY&quot;&gt;
&lt;/script&gt;</code>
                </pre>
                Add the following script to your page:
                <div class="border-b-1 my-1 border-black"></div>
                <pre><code lang="javascript"  class="text-xs text-indigo-900">{`var onGigyaServiceReady = function() {
    gigya.accounts.showScreenSet({
        screenSet: 'Default-RegistrationLogin',
        containerID: 'gigya-screen',
    });
    gigya.accounts.addEventHandlers({
        onLogin: function(e) {
            console.log('User logged in', e);
        },
        onLogout: function(e) {
            console.log('User logged out', e);
        }
    });
};`}</code></pre>
            </div>
        </article>
    </div>
    {/if}
</Page>

<style>
    .bg {
        background-image: url('/img/bg2.png');
    }
</style>